import axios from 'axios'
import store from '@/store/index'

// create an axios instance
const service = axios.create({
    baseURL: 'https://baoxiu.melouniverse.com',
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 30000, // request timeout
    headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
    }


})
// 添加请求拦截器
service.interceptors.request.use(
    config => {
        // 在发送请求之前做些什么
        const token = localStorage.getItem("token");
        // this.$store.state.
        token && (config.headers.Authorization = `Bearer ${token}`);
        return config;
    }, function (error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    });

// 添加响应拦截器
service.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    console.log('响应数据成功触发')//示例代码
    return response;//返回相应的数据
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});









export default service
